import DefaultLayout from "pages/_layouts/DefaultLayout";
import AccountOpening from "pages/accounts/AccountOpening";
import AccountOpeningSummary from "pages/accounts/AccountOpeningSummary";
import Accounts from "pages/accounts/Accounts";
import CheckTransaction from "pages/checks/CheckTransaction";
import Checks from "pages/checks/Checks";
import ChecksSummary from "pages/checks/ChecksSummary";
import AccountsOfficer from "pages/settings/AccountsOfficer";
import ChangeAddresses from "pages/settings/ChangeAddresses";
import ChangeEmail from "pages/settings/ChangeEmail";
import ChangeEmailConfirmation from "pages/settings/ChangeEmailConfirmation";
import ChangeEnvironment from "pages/settings/ChangeEnvironment";
import ChangeLanguage from "pages/settings/ChangeLanguage";
import ChangePassword from "pages/settings/ChangePassword";
import ChangePhone from "pages/settings/ChangePhone";
import ChangePhoneConfirmation from "pages/settings/ChangePhoneConfirmation";
import ChangeSecuritySeal from "pages/settings/ChangeSecuritySeal";
import ChangeSecuritySealConfirmation from "pages/settings/ChangeSecuritySealConfirmation";
import LastLogin from "pages/settings/LastLogin";
import SetDefaultEnvironment from "pages/settings/SetDefaultEnvironment";
import AccountsV2Page from "pages/v2/accounts/AccountsV2Page";
import EcheqsControl from "pages/v2/echeqs/EcheqsControl";
import EcheqsMassManageList, {
    canAccessMassEcheqManagementList,
    canCreateMassEcheqManagementBatch,
} from "pages/v2/echeqMassManagement/EcheqsMassManageList";
import EcheqsMassManageForm from "pages/v2/echeqMassManagement/EcheqsMassManageForm";
import EcheqsMassManageConfirm from "pages/v2/echeqMassManagement/EcheqsMassManageConfirm";
import EcheqsMassManageTicket from "pages/v2/echeqMassManagement/EcheqsMassManageTicket";
import EcheqsMassManageBatchDetail from "pages/v2/echeqMassManagement/EcheqsMassManageBatchDetail";
import EcheqsMassManageNotificationEntry from "pages/v2/echeqMassManagement/EcheqsMassManageNotificationEntry";
import AccountStatementsPage from "pages/v2/corporateCard/AccountStatementsPage";
import { bool, object as obj, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { selectors as sessionSelectors } from "reducers/session";
import { ENVIRONMENT_TYPE } from "constants.js";
import { getDisplay } from "util/device";
import { getEcomexPrimaryPath } from "v3/layout/buildPrivateNavItems";

import BackButtonListener from "pages/_components/BackButtonListener";
import AccountDetail from "pages/accounts/Details";
import Filters from "pages/accounts/_components/MobileFilters";
import Results from "pages/accounts/_components/MobileFiltersResults";
import MovementDetail from "pages/accounts/_components/MovementDetail";
import SetAlias from "pages/accounts/_components/SetAlias";
import AccountStatements from "pages/accounts/_components/Statements";
import Desktop from "pages/desktop/Desktop";
import PendingActions from "pages/desktop/PendingActions";
import Form from "pages/forms/Form";
import Transaction from "pages/forms/Transaction";
import FingerprintConfiguration from "pages/settings/FingerprintConfiguration";
import FingerprintDeleteConfirmation from "pages/settings/FingerprintDeleteConfirmation";
import MyDevices from "pages/settings/MyDevices";
import NotificationsConfiguration from "pages/settings/NotificationsConfiguration";
import NotificationsConfigurationTransports from "pages/settings/NotificationsConfigurationTransports";
import Settings from "pages/settings/Settings";
import DocumentsIndex from "pages/settings/_esign/DocumentsIndex";
import EsignDocumentsSigned from "pages/settings/_esign/EsignDocumentsSigned";
import SessionAboutToExpire from "pages/status/SessionAboutToExpire";
import MultipleSignaturesSummary from "pages/transactions/MultipleSignaturesSummary";
import ProcessingMultipleSignatures from "pages/transactions/ProcessingMultipleSignatures";
import TransferError from "pages/transfer/TransferError";
import TransferScheduled from "pages/transfer/TransferScheduled";
import TransferScheduledCancel from "pages/transfer/TransferScheduledCancel";
import TransferSummary from "pages/transfer/TransferSummary";
import TransferTransaction from "pages/transfer/TransferTransaction";
import TransferHistoric from "v3/pages/transfers/TransferHistoric";

import PrivacyPolicy from "pages/_components/PrivacyPolicy";
import SupportInfo from "pages/_components/SupportInfo";
import TermsAndConditions from "pages/_components/TermsAndConditions";
import HistoricBalance from "pages/accounts/HistoricBalance";
import ProyectedBalance from "pages/accounts/ProyectedBalance";
import SetProductAlias from "pages/accounts/SetProductAlias";
import MobileTransfers from "pages/accounts/_components/MobileTransfers";
import Administration from "pages/administration/Administration";
import UserInvite from "pages/administration/UserInvite";
import UserInviteGroupSignature from "pages/administration/UserInviteGroupSignature";
import UserInviteStep2 from "pages/administration/UserInviteStep2";
import UserInviteStep3 from "pages/administration/UserInviteStep3";
import AdministrationMediumSignatureTicket from "pages/administration/medium/tickets/SignatureTicket";
import CommunicationMain from "pages/communications/Main";
import NewMessage from "pages/communications/NewMessage";
import ReadMessage from "pages/communications/ReadMessage";
import ReplyMessage from "pages/communications/ReplyMessage";
import StepIRS from "pages/enrollment/StepIRS";
import FormPaymentLines from "pages/forms/FormPaymentLines";
import TransactionPaymentLines from "pages/forms/TransactionPaymentLines";
import Templates from "pages/forms/_components/Templates";
import BankSearch from "pages/forms/_components/_fields/_bankselector/bankSearch/BankSearch";
import FrequentDestinationCreate from "pages/frequentDestinations/CreateFrequentDestination";
import FrequentDestinationDetail from "pages/frequentDestinations/Details";
import FrequentDestinationList from "pages/frequentDestinations/List";
import StepPEP from "pages/onboarding/StepPEP";
import PointsOfInterest from "pages/pointsOfInterest";
import ChangeUserpass from "pages/settings/ChangeUserpass";
import PendingTransactionList from "pages/transactions/PendingTransactionList";
import TransactionsList from "pages/transactions/TransactionsList";
import TransactionsListFilters from "pages/transactions/_components/MobileFilters";
import TransactionsFiltersResults from "pages/transactions/_components/MobileFiltersResults";
/* eslint-disable */
import FrequentDestinationCreateConfirmation from "pages/frequentDestinations/_components/CreateFrequentDestinationConfirmations";
/* eslint-enable */

import FrequentDestinationDelete from "pages/frequentDestinations/DeleteConfirmation";
import ModifyFrequentDestination from "pages/frequentDestinations/ModifyFrequentDestination";
/* eslint-disable */
import ModifyFrequentDestinationConfirmations from "pages/frequentDestinations/_components/ModifyFrequentDestinationConfirmations";
/* eslint-enable */

import CreateDebinSummary from "pages/charges/CreateDebinSummary";
import DebinAddAccounts from "pages/charges/DebinAddAccounts";
import DebinAddAccountsSummary from "pages/charges/DebinAddAccountsSummary";
import DebinCancelSummary from "pages/charges/DebinCancelSummary";
import DebinRequests from "pages/charges/DebinRequests";
import SentDebinDetail from "pages/charges/SentDebinDetail";
import RequestDebin from "pages/charges/_components/RequestDebin";
import AnulateEcheqAction from "pages/checks/Echeqs/AnulateEcheqAction";
import ConfirmEcheqAction from "pages/checks/Echeqs/ConfirmEcheqAction";
import ConfirmEndorseEcheqAction from "pages/checks/Echeqs/ConfirmEndorseEcheqAction";
import EndorseEcheqStep1 from "pages/checks/Echeqs/EcheqActions/EndorseEcheqStep1";
import NegotiateEcheq from "pages/checks/Echeqs/EcheqActions/NegotiateEcheq";
import EcheqsMainPage from "pages/checks/Echeqs/EcheqsMainPage";
import EmittedEcheqsDetail from "pages/checks/Echeqs/EmittedEcheqsDetail";
import ReceivedEcheqsDetail from "pages/checks/Echeqs/ReceivedEcheqsDetail";
import RequestReturnEcheqAction from "pages/checks/Echeqs/RequestReturnEcheqAction";
import AcceptDebinConfirm from "pages/debinPayments/AcceptDebinConfirm";
import DeclineDebinConfirm from "pages/debinPayments/DeclineDebinConfirm";
import IncomingDebinList from "pages/debinPayments/IncomingDebinList";
import IncomingDebinTransaction from "pages/debinPayments/IncomingDebinTransaction";
import IncomingDebinDetail from "pages/debinPayments/_components/IncomingDebinDetail";
import DepositConstitute from "pages/deposits/DepositConstitute";
import DepositSummary from "pages/deposits/DepositSummary";
import Deposits from "pages/deposits/Deposits";
import DepositDetails from "pages/deposits/Details";
import DepositConstituteTicket from "pages/deposits/tickets/DepositConstituteTicket";
import AcceptFixedTermConfirm from "pages/fixedTermAcceptance/AcceptFixedTermConfirm";
import DeclineFixedTermConfirm from "pages/fixedTermAcceptance/DeclineFixedTermConfirm";
import FixedTermAcceptance from "pages/fixedTermAcceptance/FixedTermAcceptance";
import FixedTermAcceptanceDetail from "pages/fixedTermAcceptance/_components/FixedTermAcceptanceDetail";
import TransactionTicketCancelConfirmation from "pages/forms/_components/TransactionTicketCancelConfirmation";
import TransactionTicketSignConfirmation from "pages/forms/_components/TransactionTicketSignConfirmation";
import FrequentDestinationCreateTransfer from "pages/frequentDestinations/CreateFrequentDestinationTransfer";
import PayThirdPartiesList from "pages/payThirdParties/List";
import NewPaymentSummary from "pages/payThirdParties/newPaymenSummary";
import NewPayment from "pages/payThirdParties/newPayment";
import Token from "pages/settings/Token";
import CredinPrepareConfirmation from "pages/transfer/CredinPrepareConfirmation";
import GenerateCredin from "pages/transfer/GenerateCredin";
import RequestCredin from "pages/transfer/RequestCredin";
import DepositsConstituteV2 from "pages/v2/deposits/DepositsConstituteV2";
import CurrencyExchangePage from "pages/v2/investment/currencyExchange/CurrencyExchangePage";
import CurrencyExchangeConfirmPage from "pages/v2/investment/currencyExchange/CurrencyExchangeConfirmPage";
import CurrencyExchangeTicket from "pages/v2/investment/currencyExchange/CurrencyExchangeTicket";

import EndorseTransaction from "pages/checks/Echeqs/EcheqTransactions/EndorseTransaction";
import ThirdPaymentDetail from "pages/payThirdParties/ThirdPaymentDetail";

import EcheqTransaction from "pages/checks/Echeqs/EcheqTransactions/EcheqTransaction";
import MultipleEcheqsTransaction from "pages/checks/Echeqs/EcheqTransactions/MultipleEcheqsTransaction";
import ServiceNewPayment from "pages/servicePayments/ServiceNewPayment";
import ServicePaymentsMain from "pages/servicePayments/ServicePaymentsMain";

import ConfirmAcceptReturnEcheq from "pages/checks/Echeqs/ConfirmAcceptReturnEcheq";
import ConfirmCesionEcheqAction from "pages/checks/Echeqs/ConfirmCesionEcheqAction";
import ConfirmEmitEcheq from "pages/checks/Echeqs/ConfirmEmitEcheq";
import EmitCesion from "pages/checks/Echeqs/EcheqActions/EmitCesion";
import EmitEcheq from "pages/checks/Echeqs/EcheqActions/EmitEcheq";
import CesionEcheqTransaction from "pages/checks/Echeqs/EcheqTransactions/CesionEcheqTransaction";
import EcheqAcceptReturnTransaction from "pages/checks/Echeqs/EcheqTransactions/EcheqAcceptReturnTransaction";
import EmitEcheqTransaction from "pages/checks/Echeqs/EcheqTransactions/EmitEcheqTransaction";
import ExternalEmitEcheqTransaction from "pages/checks/Echeqs/EcheqTransactions/ExternalEmitEcheqTransaction";
import FinancingListCategories from "pages/financing/FinancingListCategories";
import FeedsDetail from "pages/financing/_components/FeedsDetail";
import FinancingDetail from "pages/financing/_components/FinancingDetail";
import FinancingId from "pages/financing/_components/FinancingId";
import AdhesionesList from "pages/servicePayments/AdhesionesList";
import NewPaymentTicket from "pages/servicePayments/NewPaymentTicket";
import UnattachServiceConfirmationTicket from "pages/servicePayments/UnattachServiceConfirmationTicket";
import TokenPassword from "pages/settings/TokenPassword";
import TokenRandomCode from "pages/settings/TokenRandomCode";
import TokenValidateRandomCode from "pages/settings/TokenValidateRandomCode";
import ChangeTokenPass from "pages/settings/_components/token/ChangeTokenPass";
import CodeActivationMobile from "pages/settings/_components/token/CodeActivationMobile";
import CodeActivationPasswordMobile from "pages/settings/_components/token/CodeAtivationPasswordMobile";
import DisabledTokenPass from "pages/settings/_components/token/DisabledTokenPass";
import RecoverToken from "pages/settings/_components/token/RecoverTokenPassword";
import TokenDrawer from "pages/settings/_components/token/TokenDrawer";

import ConsolidatedPosition from "pages/ConsolidatedPosition/ConsolidatedPosition";
import AccountOpeningTicket from "pages/accounts/AccountOpeningTicket";
import AddLimitRequestConfirmation from "pages/addlimitrequest/AddLimitRequestConfirmation";
import AcceptOrRejectCedip from "pages/cedip/AcceptOrRejectCedip";
import CedipDetail from "pages/cedip/CedipDetail";
import CedipList from "pages/cedip/CedipList";
import RejectCedipTicket from "pages/cedip/_components/RejectCedipTicket";
import ChecksDetail from "pages/checks/ChecksDetail";
import ChecksDetailInfo from "pages/checks/ChecksDetailInfo";
import DiscountedChecksDetail from "pages/checks/DiscountedChecksDetail";
import DiscountedChecksDetailInfo from "pages/checks/DiscountedChecksDetailInfo";
import BatchDetail from "pages/checks/Echeqs/Massive/BatchDetail";
import EmitMassive from "pages/checks/Echeqs/Massive/EmitMassive";
import EmitMassiveSummary from "pages/checks/Echeqs/Massive/EmitMassiveSummary";
import EmitMassiveTicket from "pages/checks/Echeqs/Massive/EmitMassiveTicket";
import EcheqRuleSummary from "pages/checks/echeqRules/EcheqRuleSummary";
import EcheqRulesMain from "pages/checks/echeqRules/EcheqRulesMain";
import ChargebackDebinConfirm from "pages/debinPayments/ChargebackDebinConfirm";
import ChargebackPullConfirm from "pages/debinPayments/ChargebackPullConfirm";
import ConfirmRecurrencyDebin from "pages/debinPayments/_components/recurrentDebin/ConfirmRecurrencyDebin";
import ConfirmRecurrencyDebinAction from "pages/debinPayments/_components/recurrentDebin/ConfirmRecurrencyDebinAction";
import LoadDebinRecurrency from "pages/debinPayments/_components/recurrentDebin/LoadDebinRecurrency";
import PrestacionTransaction from "pages/debinPayments/_components/recurrentDebin/PrestacionTransaction";
import RecurrencyDetail from "pages/debinPayments/_components/recurrentDebin/RecurrencyDetail";
import RecurrencyTransaction from "pages/debinPayments/_components/recurrentDebin/RecurrencyTransaction";
import RecurrentDebins from "pages/debinPayments/_components/recurrentDebin/RecurrentDebins";
import EcomexAlertsAndDuesMain from "pages/ecomex/EcomexAlertsAndDuesMain";
import EcomexConfirmTransaction from "pages/ecomex/EcomexConfirmTransaction";
import EcomexInformativeRegimeMain from "pages/ecomex/EcomexInformativeRegimeMain";
import EcomexOperationsMain from "pages/ecomex/EcomexOperationsMain";
import EcomexTransaction from "pages/ecomex/EcomexTransaction";
import ExcomexTransactionSuccess from "pages/ecomex/EcomexTransactionSucess";
import EcomexNewRequests from "pages/ecomex/iframe/EcomexNewRequests";
import EcomexRequestHistory from "pages/ecomex/iframe/EcomexRequestHistory";
import EnabledContributorsList from "pages/enabledContributors/EnabledContributorsList";
import FundcorpInformationMain from "pages/fundcorp/FundcorpInformationMain";
import FundcorpOperationsMain from "pages/fundcorp/FundcorpOperationsMain";
import CancelTicket from "pages/fundcorp/_components/CancelTicket";
import FundCancelSummary from "pages/fundcorp/_components/FundCancelSummary";
import FundRegisterShareAccount from "pages/fundcorp/_components/FundRegisterShareAccount";
import FundRescue from "pages/fundcorp/_components/FundRescue";
import FundRescueSummary from "pages/fundcorp/_components/FundRescueSummary";
import FundScheduledCancel from "pages/fundcorp/_components/FundScheduledCancel";
import FundSubscribe from "pages/fundcorp/_components/FundSubscribe";
import InvestorProfile from "pages/fundcorp/_components/InvestorProfile";
import RescueTicket from "pages/fundcorp/_components/RescueTicket";
import FundSubscribeSummary from "pages/fundcorp/_components/_subscribe/FundSubscribeSummary";
import ShareAccountTicket from "pages/fundcorp/_components/_subscribe/ShareAccountTicket";
import SubscribeTicket from "pages/fundcorp/_components/_subscribe/SubscribeTicket";
import MetrocorpMain from "pages/metrocorp/MetrocorpMain";
import MetrocorpOperationsV3Page from "v3/pages/metrocorp/MetrocorpOperationsV3Page";
import ThirdPaymentTicket from "pages/payThirdParties/ThirdPaymentTicket";
import AgendaPayment from "pages/servicePayments/AgendaPayment";
import AgendaPaymentDetail from "pages/servicePayments/AgendaPaymentDetail";
import AgendaServicePaymentsConfirmationTicket from "pages/servicePayments/AgendaServicePaymentsConfirmationTicket";
import DeletePaymentAFIPSummary from "pages/servicePayments/DeletePaymentAFIPSummary";
import PayPaymentAFIP from "pages/servicePayments/PayPaymentAFIP";
import PayPaymentAFIPConfirmation from "pages/servicePayments/PayPaymentAFIPConfirmation";
import PayPaymentAFIPSummary from "pages/servicePayments/PayPaymentAFIPSummary";
import PaymentAFIPDetail from "pages/servicePayments/PaymentAFIPDetail";
import ServicePaymentsConfirmationTicket from "pages/servicePayments/ServicePaymentsConfirmationTicket";
import MultipleAFIPDetail from "pages/servicePayments/multiple/MultipleAFIPDetail";
import MultipleAFIPSuccess from "pages/servicePayments/multiple/MultipleAFIPSuccess";
import MultipleAFIPSummary from "pages/servicePayments/multiple/MultipleAFIPSummary";
import MultiplePaymentAgendaDetail from "pages/servicePayments/multiple/MultiplePaymentAgendaDetail";
import MultiplePaymentsConfirmation from "pages/servicePayments/multiple/MultiplePaymentsConfirmation";
import MultiplePaymentsSuccess from "pages/servicePayments/multiple/MultiplePaymentsSuccess";
import DeletePaymentAFIPTicket from "pages/servicePayments/tickets/DeletePaymentAFIPTicket";
import PayPaymentAFIPTicket from "pages/servicePayments/tickets/PayPaymentAFIPTicket";
import ListDevices from "pages/settings/pushNotifications/ListDevices";
import QAlertConfiguration from "pages/settings/pushNotifications/QAlertConfiguration";
import AddLimitTicket from "pages/temporarylimits/AddLimitTicket";
import ExternalTransaction from "pages/transactions/ExternalTransaction";
import MultipleSignaturesDelete from "pages/transactions/MultipleSignaturesDelete";
import ProcessingMultipleDelete from "pages/transactions/ProcessingMultipleDelete";
import MultipleTransfer from "pages/transfer/multiple/MultipleTransfer";
import MultipleTransferDashboard from "pages/transfer/multiple/MultipleTransferDashboard";
import MultipleTransferDetail from "pages/transfer/multiple/MultipleTransferDetail";
import MultipleTransferSummary from "pages/transfer/multiple/MultipleTransferSummary";
import MultipleTransferTicket from "pages/transfer/multiple/MultipleTransferTicket";
import AddLimitRequest from "pages/v2/addlimitrequest/AddLimitRequest";
import Agenda from "pages/v2/agenda/Agenda";
import CreateContactPage from "pages/v2/agenda/CreateContact";
import DebinScheduledConfirmationPage from "pages/v2/debin/scheduled/DebinScheduledConfirmationPage";
import DebinScheduledDetail from "pages/v2/debin/scheduled/DebinScheduledDetail";
import ProgrammedDebin from "pages/v2/debin/scheduled/ProgrammedDebin";
import DetailDirectDebit from "pages/v2/directDebit/DetailDirectDebit";
import ListDirectDebit from "pages/v2/directDebit/ListDirectDebit";
import NewDirectDebit from "pages/v2/directDebit/NewDirectDebit";
import NewDirectDebitSummary from "pages/v2/directDebit/NewDirectDebitSummary";
import NewDirectDebitSummaryData from "pages/v2/directDebit/NewDirectDebitSummaryData";
import NewDirectDebitTransaction from "pages/v2/directDebit/NewDirectDebitTransaction";
import CreateEcheqRule from "pages/v2/echeq/CreateEcheqRule";
import CreateEcheqRuleConfirmation from "pages/v2/echeq/CreateEcheqRuleConfirmation";
import CreateEcheqRuleTransaction from "pages/v2/echeq/CreateEcheqRuleTransaction";
import TransferDownload from "pages/v2/transfer/TransferDownload";
import V2Transfer from "pages/v2/transfer/V2Transfer";
import ActivateTokenWithBiometrics from "pages/v2/transfer/settings/ActivateTokenWithBiometrics";
import DisableBiometricToken from "pages/v2/transfer/settings/DisableBiometricToken";
import HideBalancePage from "pages/v2/transfer/settings/HideBalancePage";
import TokenSeedError from "pages/v2/transfer/settings/TokenSeedError";

import { isUxDashboardImprovementsEnabled, isUxMetrocorpImprovementsEnabled } from "util/v3ShellLayoutSync";
import { METROCORP_HOLDINGS_V3_PATH, METROCORP_SOAP_PATH } from "util/metrocorpRoutes";
import { getTransferHistoricPath, TRANSFER_HISTORIC_LEGACY_PATH } from "util/v3UxConfig";
import NewPaymentThirdParty from "pages/v2/payThirdParties/NewPaymentThirdParty";
import PaymentsMultipleArcaTransaction from "pages/v2/payments/PaymentsMultipleArcaTransaction";
import PaymentsServicesArca from "pages/v2/payments/PaymentsServicesArca";
import PaymentServicesArcaConfirmationPage from "pages/v2/payments/PaymentServicesArcaConfirmationPage";

/** Legacy-only (UX dashboard off): `/financing` and `/ecomex` index via DefaultLayout, mirroring v3 shell redirects. */
const LegacyFinancingIndexRedirect = connect((state) => ({
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
}))(({ activeEnvironment }) => {
    const canFinancingList = !!activeEnvironment?.permissions?.financingList;
    return canFinancingList ? <Redirect to="/financing/categories" /> : <Redirect to="/desktop" />;
});

function MetrocorpLegacyRoute(props) {
    if (isUxMetrocorpImprovementsEnabled()) {
        return <Redirect to={METROCORP_HOLDINGS_V3_PATH} />;
    }
    return <MetrocorpMain {...props} />;
}

function MetrocorpV3Route(props) {
    if (!isUxMetrocorpImprovementsEnabled()) {
        return <Redirect to={METROCORP_SOAP_PATH} />;
    }
    return <MetrocorpOperationsV3Page {...props} />;
}

const LegacyEcomexIndexRedirect = connect((state) => ({
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
}))(({ activeEnvironment }) => {
    const isRetailEnvironment = activeEnvironment?.type === ENVIRONMENT_TYPE.RETAIL;
    const display = getDisplay();
    const isMobile = display === "mobile" || display === "tablet";
    const landing = getEcomexPrimaryPath(activeEnvironment, isMobile, isRetailEnvironment);
    return landing ? <Redirect to={landing} /> : <Redirect to="/desktop" />;
});

const TransferHistoricLegacyEntry = () => {
    if (getTransferHistoricPath() !== TRANSFER_HISTORIC_LEGACY_PATH) {
        return <Redirect to={getTransferHistoricPath()} />;
    }
    return <TransferHistoric />;
};

class PrivateRoutes extends Component {
    static propTypes = {
        hasActiveSession: bool,
        activeEnvironment: shape({
            permissions: shape({
                accounts: bool,
                requestTransactionCancellation: bool,
                transferForeign: bool,
                transferInternal: bool,
                transferLocal: bool,
                transferThirdParties: bool,
            }),
            forms: obj,
            administrationScheme: string,
            type: string,
        }).isRequired,
        isAdministrator: bool,
        uxDashboardImprovements: bool.isRequired,
    };

    static defaultProps = {
        hasActiveSession: false,
        isAdministrator: false,
    };

    render() {
        const { hasActiveSession, activeEnvironment, isAdministrator, uxDashboardImprovements } = this.props;

        if (!hasActiveSession) {
            return <Redirect to="/" />;
        }
        if (uxDashboardImprovements) {
            return (
                <>
                    <Switch>
                        <Route path="/desktop" component={() => <Redirect to="/v3/dashboard" />} />
                    </Switch>
                    <BackButtonListener />
                    <Route path="/" component={SessionAboutToExpire} />
                </>
            );
        }

        return (
            <>
                <Switch>
                    <DefaultLayout exact path="/desktop" component={Desktop} />
                    <DefaultLayout
                        key="/ConsolidatedPosition"
                        exact
                        path="/ConsolidatedPosition"
                        component={ConsolidatedPosition}
                    />

                    <DefaultLayout exact path="/pendingActions" component={PendingActions} withoutLayout />
                    <DefaultLayout exact path="/completePEP" component={StepPEP} withoutLayout />
                    <DefaultLayout exact path="/completeIRS" component={StepIRS} withoutLayout />
                    {/* CHECKS (shell v3: `v3PrivateShellRoutes.jsx` cuando UX dashboard on) */}
                    <DefaultLayout
                        key="/checks"
                        authorizedRoute={!!activeEnvironment?.permissions.requestCheckbook}
                        exact
                        path="/checks"
                        component={Checks}
                    />
                    <DefaultLayout
                        key="/checks/summary"
                        authorizedRoute={!!activeEnvironment?.permissions.requestCheckbook}
                        exact
                        path="/checks/summary"
                        component={ChecksSummary}
                    />
                    <DefaultLayout
                        key="/checks/back"
                        authorizedRoute={!!activeEnvironment?.permissions.requestCheckbook}
                        exact
                        path="/checks/back"
                        component={Checks}
                    />
                    <DefaultLayout
                        key="/checks/modify"
                        authorizedRoute={!!activeEnvironment?.permissions.requestCheckbook}
                        exact
                        path="/checks/modify"
                        component={Checks}
                    />
                    <DefaultLayout
                        key="/checks/transaction"
                        authorizedRoute={!!activeEnvironment?.permissions.requestCheckbook}
                        exact
                        path="/checks/transaction"
                        component={CheckTransaction}
                    />
                    <DefaultLayout
                        key="/checksDetail"
                        authorizedRoute={!!activeEnvironment?.permissions["checks.detail.view"]}
                        exact
                        path="/checksDetail"
                        component={ChecksDetail}
                    />
                    <DefaultLayout
                        key="/checksDetail/:checkNumber"
                        exact
                        path="/checksDetail/:checkNumber"
                        component={ChecksDetailInfo}
                    />
                    <DefaultLayout
                        key="/discountedChecksDetail"
                        exact
                        path="/discountedChecksDetail"
                        component={DiscountedChecksDetail}
                    />
                    <DefaultLayout
                        key="/discountedChecksDetail/:checkNumber"
                        exact
                        path="/discountedChecksDetail/:checkNumber"
                        component={DiscountedChecksDetailInfo}
                    />
                    {/* ACCOUNTS */}
                    <DefaultLayout exact path="/accounts" component={Accounts} />

                    <DefaultLayout key="/v2/accounts" exact path="/v2/accounts" component={AccountsV2Page} />

                    <DefaultLayout key="/v2/echeqs/control" exact path="/v2/echeqs/control" component={EcheqsControl} />
                    <DefaultLayout
                        key="/echeqs/mass-management/:envId/:envName"
                        path="/echeqs/mass-management/:envId/:envName"
                        authorizedRoute={canAccessMassEcheqManagementList(activeEnvironment?.permissions)}
                        component={EcheqsMassManageNotificationEntry}
                    />
                    <DefaultLayout
                        key="/v2/echeqs/mass-management"
                        exact
                        path="/v2/echeqs/mass-management"
                        authorizedRoute={canAccessMassEcheqManagementList(activeEnvironment?.permissions)}
                        component={EcheqsMassManageList}
                    />
                    <DefaultLayout
                        key="/v2/echeqs/mass-management/new"
                        exact
                        path="/v2/echeqs/mass-management/new"
                        authorizedRoute={canCreateMassEcheqManagementBatch(activeEnvironment?.permissions)}
                        component={EcheqsMassManageForm}
                    />
                    <DefaultLayout
                        key="/v2/echeqs/mass-management/confirm"
                        exact
                        path="/v2/echeqs/mass-management/confirm"
                        authorizedRoute={canCreateMassEcheqManagementBatch(activeEnvironment?.permissions)}
                        component={EcheqsMassManageConfirm}
                    />
                    <DefaultLayout
                        key="/v2/echeqs/mass-management/ticket"
                        exact
                        path="/v2/echeqs/mass-management/ticket"
                        authorizedRoute={canCreateMassEcheqManagementBatch(activeEnvironment?.permissions)}
                        component={EcheqsMassManageTicket}
                    />
                    <DefaultLayout
                        key="/v2/echeqs/mass-management/:idBatch/detail"
                        exact
                        path="/v2/echeqs/mass-management/:idBatch/detail"
                        authorizedRoute={canAccessMassEcheqManagementList(activeEnvironment?.permissions)}
                        component={EcheqsMassManageBatchDetail}
                    />

                    <DefaultLayout
                        key="/v2/corporateCard/accountStatements"
                        exact
                        path="/v2/corporateCard/accountStatements"
                        component={AccountStatementsPage}
                    />

                    <DefaultLayout key="/accountOpening" exact path="/accountOpening" component={AccountOpening} />
                    <DefaultLayout
                        key="/accountOpening/back"
                        exact
                        path="/accountOpening/back"
                        component={AccountOpening}
                    />
                    <DefaultLayout
                        key="/accountOpening/modify"
                        exact
                        path="/accountOpening/modify"
                        component={AccountOpening}
                    />
                    <DefaultLayout
                        key="/accountOpening/summary"
                        exact
                        path="/accountOpening/summary"
                        component={AccountOpeningSummary}
                    />
                    <DefaultLayout
                        key="/accountOpening/transaction"
                        exact
                        path="/accountOpening/transaction"
                        component={AccountOpeningTicket}
                    />

                    <DefaultLayout key="/accounts/:id" exact path="/accounts/:id" component={AccountDetail} />

                    <DefaultLayout exact path="/accounts/:id/movement" component={MovementDetail} />
                    <DefaultLayout exact path="/accounts/:id/setAlias" component={SetAlias} />
                    <DefaultLayout exact path="/accounts/:id/statements" component={AccountStatements} />
                    <DefaultLayout exact path="/accounts/:id/filters" component={Filters} />
                    <DefaultLayout exact path="/accounts/:id/filters/results" component={Results} />
                    <DefaultLayout exact path="/accounts/:id/transfers" component={MobileTransfers} />
                    <DefaultLayout
                        key="/account/proyectedBalance/:id"
                        exact
                        path="/account/proyectedBalance/:id"
                        component={ProyectedBalance}
                    />
                    <DefaultLayout
                        key="/account/historicBalance/:id"
                        exact
                        path="/account/historicBalance/:id"
                        component={HistoricBalance}
                    />
                    <DefaultLayout exact path="/account/:id/setProductAlias" component={SetProductAlias} />
                    {/* SETTINGS */}
                    <DefaultLayout exact path="/settings" component={Settings} />

                    <DefaultLayout exact path="/settings/changePassword" component={ChangePassword} />

                    <DefaultLayout exact path="/settings/changeUserpass" component={ChangeUserpass} />

                    <DefaultLayout exact path="/settings/changeSecuritySeal" component={ChangeSecuritySeal} />

                    <DefaultLayout
                        exact
                        path="/settings/changeSecuritySeal/confirmation"
                        component={ChangeSecuritySealConfirmation}
                    />

                    <DefaultLayout
                        exact
                        path="/settings/notificationsConfiguration"
                        component={NotificationsConfiguration}
                    />

                    <DefaultLayout
                        path="/settings/notificationsConfiguration/:communicationType"
                        component={NotificationsConfigurationTransports}
                    />

                    <DefaultLayout
                        exact
                        path="/settings/fingerprintConfiguration"
                        component={FingerprintConfiguration}
                    />

                    <DefaultLayout
                        exact
                        path="/settings/fingerprintConfiguration/deleteConfirmation"
                        component={FingerprintDeleteConfirmation}
                    />

                    <DefaultLayout exact path="/settings/notificationsPushDevices" component={ListDevices} />

                    <DefaultLayout exact path="/settings/myDevices" component={MyDevices} />

                    <DefaultLayout exact path="/settings/token" component={Token} />
                    <DefaultLayout exact path="/settings/token/request" component={TokenDrawer} />
                    <DefaultLayout exact path="/settings/token/codeActivation" component={CodeActivationMobile} />
                    <DefaultLayout
                        exact
                        path="/settings/token/codeActivation/changuedPassword"
                        component={CodeActivationPasswordMobile}
                    />
                    <DefaultLayout
                        exact
                        path="/settings/token/codeActivation/biometricActivation"
                        component={ActivateTokenWithBiometrics}
                    />
                    <DefaultLayout exact path="/settings/token/ChangeTokenPass" component={ChangeTokenPass} />
                    <DefaultLayout exact path="/settings/token/tokenPassword" component={TokenPassword} />
                    <DefaultLayout exact path="/settings/token/tokenRandomCode" component={TokenRandomCode} />
                    <DefaultLayout exact path="/settings/token/recoverPass" component={RecoverToken} />
                    <DefaultLayout exact path="/settings/token/disabledTokenPass" component={DisabledTokenPass} />
                    <DefaultLayout
                        exact
                        path="/settings/token/disableBiometricToken"
                        component={DisableBiometricToken}
                    />
                    <DefaultLayout
                        exact
                        path="/settings/token/synchronization/ValidateRandomCode"
                        component={TokenValidateRandomCode}
                    />
                    <DefaultLayout
                        exact
                        path="/settings/token/synchronization/tokenPassword"
                        component={TokenPassword}
                    />
                    <DefaultLayout
                        exact
                        path="/settings/token/synchronization/biometricActivation"
                        component={ActivateTokenWithBiometrics}
                    />
                    <DefaultLayout exact path="/settings/token/tokenSeedError" component={TokenSeedError} />

                    <DefaultLayout exact path="/accountsOfficer" component={AccountsOfficer} />

                    <DefaultLayout exact path="/settings/esign/documents" component={DocumentsIndex} />
                    <DefaultLayout exact path="/settings/esign/documentsSigned" component={EsignDocumentsSigned} />

                    <DefaultLayout exact path="/settings/changeEnvironment" component={ChangeEnvironment} />

                    <DefaultLayout exact path="/settings/setDefaultEnvironment" component={SetDefaultEnvironment} />

                    <DefaultLayout exact path="/settings/changeLanguage" component={ChangeLanguage} />

                    <DefaultLayout exact path="/settings/changeEmail" component={ChangeEmail} />

                    <DefaultLayout
                        exact
                        path="/settings/changeEmail/confirmation"
                        component={ChangeEmailConfirmation}
                    />

                    <DefaultLayout exact path="/settings/ChangeAddresses" component={ChangeAddresses} />

                    <DefaultLayout exact path="/settings/changePhone" component={ChangePhone} />

                    <DefaultLayout
                        exact
                        path="/settings/changePhone/confirmation"
                        component={ChangePhoneConfirmation}
                    />

                    <DefaultLayout exact path="/settings/LastLogin" component={LastLogin} />

                    <DefaultLayout exact path="/settings/pointsOfInterest" component={PointsOfInterest} />

                    <DefaultLayout exact path="/v2/settings/hidebalance" component={HideBalancePage} />

                    <DefaultLayout exact path="/settings/qAlert" component={QAlertConfiguration} />
                    {/* TRANSFERS */}
                    <DefaultLayout
                        key="/transfer/multiple"
                        exact
                        path="/transfer/multiple"
                        component={MultipleTransferDashboard}
                        authorizedRoute={!!activeEnvironment?.permissions?.transferMultiple}
                    />
                    <DefaultLayout
                        key="/transfer/multiple/detail/:id"
                        exact
                        path="/transfer/multiple/detail/:id"
                        component={MultipleTransferDetail}
                        authorizedRoute={!!activeEnvironment?.permissions?.transferMultiple}
                    />
                    <DefaultLayout
                        key="/transfer/multiple/create"
                        exact
                        path="/transfer/multiple/create"
                        component={MultipleTransfer}
                        authorizedRoute={!!activeEnvironment?.permissions?.transferMultiple}
                    />
                    <DefaultLayout
                        key="/transfer/multiple/confirm"
                        exact
                        path="/transfer/multiple/confirm"
                        component={MultipleTransferSummary}
                        authorizedRoute={!!activeEnvironment?.permissions?.transferMultiple}
                    />
                    <DefaultLayout
                        key="/transfer/multiple/cancelled"
                        exact
                        path="/transfer/multiple/cancelled"
                        component={MultipleTransferTicket}
                        authorizedRoute={!!activeEnvironment?.permissions?.transferMultiple}
                    />
                    <DefaultLayout
                        key="/transfer/multiple/pending"
                        exact
                        path="/transfer/multiple/pending"
                        component={MultipleTransferTicket}
                        authorizedRoute={!!activeEnvironment?.permissions?.transferMultiple}
                    />
                    <DefaultLayout
                        key="/transfer/multiple/failed"
                        exact
                        path="/transfer/multiple/failed"
                        component={MultipleTransferTicket}
                        authorizedRoute={!!activeEnvironment?.permissions?.transferMultiple}
                    />
                    <DefaultLayout
                        key="/transfer/multiple/confirmation"
                        exact
                        path="/transfer/multiple/confirmation"
                        component={MultipleTransferTicket}
                        authorizedRoute={!!activeEnvironment?.permissions?.transferMultiple}
                    />
                    <DefaultLayout
                        key="/transfer/cancelled"
                        exact
                        path="/transfer/cancelled"
                        component={TransferTransaction}
                    />
                    <DefaultLayout key="/transfer/summary" exact path="/transfer/summary" component={TransferSummary} />
                    <DefaultLayout
                        key="/transfer/confirmation"
                        exact
                        path="/transfer/confirmation"
                        component={TransferTransaction}
                    />
                    <DefaultLayout
                        key="/transfer/failed"
                        exact
                        path="/transfer/failed"
                        component={TransferTransaction}
                    />
                    <DefaultLayout
                        key="/transfer/scheduled"
                        exact
                        path="/transfer/scheduled"
                        component={TransferScheduled}
                    />
                    <DefaultLayout
                        key="/transfer/scheduled/cancel"
                        exact
                        path="/transfer/scheduled/cancel"
                        component={TransferScheduledCancel}
                    />
                    <DefaultLayout
                        key="/transfer/pending"
                        exact
                        path="/transfer/pending"
                        component={TransferTransaction}
                    />
                    <DefaultLayout key="/transfer/error" exact path="/transfer/error" component={TransferError} />
                    <DefaultLayout
                        key="/FrequentDestination"
                        authorizedRoute={!!activeEnvironment?.permissions.frequentDestination}
                        exact
                        path="/FrequentDestination"
                        component={FrequentDestinationList}
                    />
                    <DefaultLayout
                        key="/FrequentDestination/create/step1"
                        exact
                        authorizedRoute={!!activeEnvironment?.permissions["frequentDestination.manage"]}
                        path="/FrequentDestination/create/step1"
                        component={FrequentDestinationCreate}
                    />
                    <DefaultLayout
                        key="/frequentDestination/create/:id/confirm"
                        exact
                        authorizedRoute={!!activeEnvironment?.permissions["frequentDestination.manage"]}
                        path="/frequentDestination/create/:id/confirm"
                        component={FrequentDestinationCreateConfirmation}
                    />
                    <DefaultLayout
                        key="/FrequentDestination/detail/:id/"
                        exact
                        authorizedRoute={!!activeEnvironment?.permissions["frequentDestination.manage"]}
                        path="/FrequentDestination/detail/:id/"
                        component={FrequentDestinationDetail}
                    />
                    <DefaultLayout
                        key="/transfer/frequentDestination/:id/create/"
                        exact
                        authorizedRoute={!!activeEnvironment?.permissions["frequentDestination.manage"]}
                        path="/transfer/frequentDestination/:id/create/"
                        component={FrequentDestinationCreateTransfer}
                    />
                    <DefaultLayout
                        key="/frequentDestination/:id/delete"
                        exact
                        authorizedRoute={!!activeEnvironment?.permissions["frequentDestination.manage"]}
                        path="/frequentDestination/:id/delete"
                        component={FrequentDestinationDelete}
                    />
                    <DefaultLayout
                        key="/frequentDestination/:id/modify"
                        exact
                        authorizedRoute={!!activeEnvironment?.permissions["frequentDestination.manage"]}
                        path="/frequentDestination/:id/modify"
                        component={ModifyFrequentDestination}
                    />
                    <DefaultLayout
                        key="/frequentDestination/:id/modify/confirmation"
                        exact
                        authorizedRoute={!!activeEnvironment?.permissions["frequentDestination.manage"]}
                        path="/frequentDestination/:id/modify/confirmation"
                        component={ModifyFrequentDestinationConfirmations}
                    />
                    <DefaultLayout
                        key="/v2/agenda"
                        authorizedRoute={!!activeEnvironment?.permissions.frequentDestination}
                        exact
                        path="/v2/agenda"
                        component={Agenda}
                    />
                    <DefaultLayout
                        key="/v2/agenda/create"
                        authorizedRoute={!!activeEnvironment?.permissions["frequentDestination.manage"]}
                        exact
                        path="/v2/agenda/create"
                        component={CreateContactPage}
                    />

                    <DefaultLayout key="/requestCredin" exact path="/requestCredin" component={RequestCredin} />

                    <DefaultLayout
                        key="/requestCredin/generateCredin"
                        exact
                        path="/requestCredin/generateCredin"
                        component={GenerateCredin}
                    />

                    <DefaultLayout
                        key="/confirmCredin/transaction"
                        exact
                        path="/confirmCredin/transaction"
                        component={CredinPrepareConfirmation}
                    />

                    {/* TRANSFERENCIAS V2 — shell v3 cuando UX dashboard; si no, aquí (legacy layout) */}
                    <DefaultLayout
                        key="/v2/transfer/historic"
                        exact
                        path="/v2/transfer/historic"
                        component={TransferHistoricLegacyEntry}
                    />
                    <DefaultLayout
                        key="/v2/transferDownload"
                        exact
                        path="/v2/transferDownload"
                        component={TransferDownload}
                    />
                    <DefaultLayout
                        key="/v2/transfer/:transferType"
                        exact
                        path="/v2/transfer/:transferType"
                        component={V2Transfer}
                    />
                    <DefaultLayout
                        key="/v2/transfer/:transferType/modify"
                        exact
                        path="/v2/transfer/:transferType/modify"
                        component={V2Transfer}
                    />
                    <DefaultLayout
                        key="/v2/transfer/:transferType/back"
                        exact
                        path="/v2/transfer/:transferType/back"
                        component={V2Transfer}
                    />
                    {/* ECHEQS — shell v3 cuando UX dashboard */}
                    <DefaultLayout
                        key="/echeqs"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs"
                        component={EcheqsMainPage}
                    />
                    <DefaultLayout
                        key="/echeqs/summary/:envId/:envName/:state"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/summary/:envId/:envName/:state"
                        component={EcheqsMainPage}
                    />
                    <DefaultLayout
                        key="/echeqs/single/:envId/:envName/:echeqId/:echeqType"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/single/:envId/:envName/:echeqId/:echeqType"
                        component={EcheqsMainPage}
                    />
                    <DefaultLayout
                        key="/echeqs/single/:envId/:envName/:echeqId/:echeqType/:currency"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/single/:envId/:envName/:echeqId/:echeqType/:currency"
                        component={EcheqsMainPage}
                    />
                    <DefaultLayout
                        key="/echeqs/action/confirmation"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/action/confirmation"
                        component={ConfirmEcheqAction}
                    />
                    <DefaultLayout
                        key="/echeqs/return/confirmation"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/return/confirmation"
                        component={RequestReturnEcheqAction}
                    />
                    <DefaultLayout
                        key="/echeqs/anulate/confirmation"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/anulate/confirmation"
                        component={AnulateEcheqAction}
                    />
                    <DefaultLayout
                        key="/echeqs/action/endorse"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/action/endorse"
                        component={EndorseEcheqStep1}
                    />
                    <DefaultLayout
                        key="/echeqs/action/cesion"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/action/cesion"
                        component={EmitCesion}
                    />
                    <DefaultLayout
                        key="/echeqs/action/cesion/confirm"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/action/cesion/confirm"
                        component={ConfirmCesionEcheqAction}
                    />
                    <DefaultLayout
                        key="/echeqs/action/negotiate"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/action/negotiate"
                        component={NegotiateEcheq}
                    />
                    <DefaultLayout
                        key="/echeqs/action/return/accept"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/action/return/accept"
                        component={ConfirmAcceptReturnEcheq}
                    />
                    <DefaultLayout
                        key="/echeqs/action/endorse/confirm"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/action/endorse/confirm"
                        component={ConfirmEndorseEcheqAction}
                    />
                    <DefaultLayout
                        key="/echeqs/received/detail/:echeqId"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/received/detail/:echeqId"
                        component={ReceivedEcheqsDetail}
                    />
                    <DefaultLayout
                        key="/echeqs/emitted/detail/:echeqId"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/emitted/detail/:echeqId"
                        component={EmittedEcheqsDetail}
                    />
                    <DefaultLayout
                        key="/echeqs/confirm/endorse"
                        exact
                        path="/echeqs/confirm/endorse"
                        component={EndorseTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/pending/endorse"
                        exact
                        path="/echeqs/pending/endorse"
                        component={EndorseTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/cancelled/endorse"
                        exact
                        path="/echeqs/cancelled/endorse"
                        component={EndorseTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/failed/endorse"
                        exact
                        path="/echeqs/failed/endorse"
                        component={EndorseTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/transaction/action"
                        exact
                        path="/echeqs/transaction/action"
                        component={EcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/pending/certificate"
                        exact
                        path="/echeqs/pending/certificate"
                        component={EcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/return/accept/transaction"
                        exact
                        path="/echeqs/return/accept/transaction"
                        component={EcheqAcceptReturnTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/multiple/:status"
                        exact
                        path="/echeqs/multiple/:status"
                        component={MultipleEcheqsTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/emit"
                        authorizedRoute={!!activeEnvironment?.permissions["operate.echeqs"]}
                        exact
                        path="/echeqs/emit"
                        component={EmitEcheq}
                    />
                    <DefaultLayout
                        key="/echeqs/action/emit/confirm"
                        exact
                        path="/echeqs/action/emit/confirm"
                        component={ConfirmEmitEcheq}
                    />
                    <DefaultLayout
                        key="/echeqs/confirm/emit"
                        exact
                        path="/echeqs/confirm/emit"
                        component={EmitEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/failed/emit"
                        exact
                        path="/echeqs/failed/emit"
                        component={EmitEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/pending/emit"
                        exact
                        path="/echeqs/pending/emit"
                        component={EmitEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/cancelled/emit"
                        exact
                        path="/echeqs/cancelled/emit"
                        component={EmitEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/confirm/cesion"
                        exact
                        path="/echeqs/confirm/cesion"
                        component={CesionEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/failed/cesion"
                        exact
                        path="/echeqs/failed/cesion"
                        component={CesionEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/pending/cesion"
                        exact
                        path="/echeqs/pending/cesion"
                        component={CesionEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/cancelled/cesion"
                        exact
                        path="/echeqs/cancelled/cesion"
                        component={CesionEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/confirm/external/emit"
                        exact
                        path="/echeqs/confirm/external/emit"
                        component={ExternalEmitEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/failed/external/emit"
                        exact
                        path="/echeqs/failed/external/emit"
                        component={ExternalEmitEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/pending/external/emit"
                        exact
                        path="/echeqs/pending/external/emit"
                        component={ExternalEmitEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/cancelled/external/emit"
                        exact
                        path="/echeqs/cancelled/external/emit"
                        component={ExternalEmitEcheqTransaction}
                    />
                    <DefaultLayout
                        key="/echeqs/emit/massive"
                        authorizedRoute={!!activeEnvironment?.permissions?.massiveEmitEcheq}
                        exact
                        path="/echeqs/emit/massive"
                        component={EmitMassive}
                    />
                    <DefaultLayout
                        key="/echeqs/emit/massive/confirm"
                        exact
                        path="/echeqs/emit/massive/confirm"
                        component={EmitMassiveSummary}
                    />
                    <DefaultLayout
                        key="/echeqs/emitMassive/confirmation"
                        exact
                        path="/echeqs/emitMassive/confirmation"
                        component={EmitMassiveTicket}
                    />
                    <DefaultLayout
                        key="/echeqs/emitMassive/pending"
                        exact
                        path="/echeqs/emitMassive/pending"
                        component={EmitMassiveTicket}
                    />
                    <DefaultLayout
                        key="/echeqs/emitMassive/failed"
                        exact
                        path="/echeqs/emitMassive/failed"
                        component={EmitMassiveTicket}
                    />
                    <DefaultLayout
                        key="/echeqs/emitMassive/cancelled"
                        exact
                        path="/echeqs/emitMassive/cancelled"
                        component={EmitMassiveTicket}
                    />
                    <DefaultLayout
                        key="/echeqs/emit/massive/:idTransaction/detail"
                        exact
                        path="/echeqs/emit/massive/:idTransaction/detail"
                        component={BatchDetail}
                    />
                    <DefaultLayout
                        key="/v2/echeqRules/create"
                        exact
                        path="/v2/echeqRules/create"
                        component={CreateEcheqRule}
                    />
                    <DefaultLayout
                        key="/v2/echeqRules/create/confirmation"
                        exact
                        path="/v2/echeqRules/create/confirmation"
                        component={CreateEcheqRuleConfirmation}
                    />
                    <DefaultLayout
                        key="/echeqRules/create/transaction"
                        exact
                        path="/echeqRules/create/transaction"
                        component={CreateEcheqRuleTransaction}
                    />
                    <DefaultLayout key="/v2/echeqRules" exact path="/v2/echeqRules" component={EcheqRulesMain} />

                    <DefaultLayout
                        key="/echeqRules/confirm/:action"
                        authorizedRoute={!!activeEnvironment?.permissions["rule.manage.echeq"]}
                        exact
                        path="/echeqRules/confirm/:action"
                        component={EcheqRuleSummary}
                    />

                    {/* SERVICE-PAYMENTS */}
                    <DefaultLayout
                        key="/newPayment"
                        authorizedRoute={!!activeEnvironment?.permissions["pay.afip"]}
                        exact
                        path="/newPayment"
                        component={ServiceNewPayment}
                    />
                    <DefaultLayout
                        key="/v2/payments-services"
                        authorizedRoute={
                            !!(
                                activeEnvironment?.permissions["pay.afip"] &&
                                activeEnvironment?.permissions["service.payments.view"]
                            )
                        }
                        exact
                        path="/v2/payments-services"
                        component={PaymentsServicesArca}
                    />
                    <DefaultLayout
                        key="/v2/payAFIPSummary"
                        exact
                        path="/v2/payAFIPSummary"
                        component={PaymentServicesArcaConfirmationPage}
                    />
                    <DefaultLayout
                        key="/servicePayments"
                        authorizedRoute={
                            !!(
                                activeEnvironment?.permissions["pay.afip"] &&
                                activeEnvironment?.permissions["service.payments.view"]
                            )
                        }
                        exact
                        path="/servicePayments"
                        component={ServicePaymentsMain}
                    />
                    <DefaultLayout
                        key="/servicePaymentsConfirmationTicket"
                        exact
                        path="/servicePaymentsConfirmationTicket"
                        component={ServicePaymentsConfirmationTicket}
                    />
                    <DefaultLayout
                        key="/newPayment/pending"
                        exact
                        path="/newPayment/pending"
                        component={NewPaymentTicket}
                    />
                    <DefaultLayout
                        key="/newPayment/cancelled"
                        exact
                        path="/newPayment/cancelled"
                        component={NewPaymentTicket}
                    />
                    <DefaultLayout
                        key="/newPayment/confirmation"
                        exact
                        path="/newPayment/confirmation"
                        component={NewPaymentTicket}
                    />
                    <DefaultLayout
                        key="/adhesiones/list"
                        authorizedRoute={!!activeEnvironment?.permissions["pay.afip"]}
                        exact
                        path="/adhesiones/list"
                        component={AdhesionesList}
                    />
                    <DefaultLayout
                        key="/payMultipleAFIPSummary"
                        exact
                        path="/payMultipleAFIPSummary"
                        component={MultipleAFIPSummary}
                    />
                    <DefaultLayout
                        key="/deletePaymentAFIPSummary"
                        exact
                        path="/deletePaymentAFIPSummary"
                        component={DeletePaymentAFIPSummary}
                    />
                    <DefaultLayout
                        key="/payments/enabledContributors"
                        exact
                        path="/payments/enabledContributors"
                        component={EnabledContributorsList}
                    />
                    <DefaultLayout
                        key="/desadherir/confirmation"
                        exact
                        path="/desadherir/confirmation"
                        component={UnattachServiceConfirmationTicket}
                    />
                    <DefaultLayout
                        key="/payMultipleAFIPSuccess"
                        exact
                        path="/payMultipleAFIPSuccess"
                        component={MultipleAFIPSuccess}
                    />
                    <DefaultLayout
                        key="/v2/payMultipleAFIP/success"
                        exact
                        path="/v2/payMultipleAFIP/success"
                        component={PaymentsMultipleArcaTransaction}
                    />
                    <DefaultLayout
                        key="/payMultipleAFIPDetail"
                        exact
                        path="/payMultipleAFIPDetail"
                        component={MultipleAFIPDetail}
                    />
                    <DefaultLayout
                        key="/payPaymentAFIPSummary"
                        exact
                        path="/payPaymentAFIPSummary"
                        component={PayPaymentAFIPSummary}
                    />
                    <DefaultLayout
                        key="/payPaymentAFIPConfirmation"
                        exact
                        path="/payPaymentAFIPConfirmation"
                        component={PayPaymentAFIPConfirmation}
                    />
                    <DefaultLayout
                        key="/payPaymentAFIP/:idTransaction/ticket"
                        exact
                        path="/payPaymentAFIP/:idTransaction/ticket"
                        component={PayPaymentAFIPTicket}
                    />
                    <DefaultLayout
                        key="/deletePaymentAFIP/:idTransaction/ticket"
                        exact
                        path="/deletePaymentAFIP/:idTransaction/ticket"
                        component={DeletePaymentAFIPTicket}
                    />
                    <DefaultLayout
                        key="/multiplePaymentsConfirmation"
                        exact
                        path="/multiplePaymentsConfirmation"
                        component={MultiplePaymentsConfirmation}
                    />
                    <DefaultLayout
                        key="/multiplePaymentsSuccess"
                        exact
                        path="/multiplePaymentsSuccess"
                        component={MultiplePaymentsSuccess}
                    />
                    <DefaultLayout exact path="/payPaymentAFIP" component={PayPaymentAFIP} />
                    <DefaultLayout exact path="/paymentAFIP" component={PaymentAFIPDetail} />
                    <DefaultLayout exact path="/agenda/payment" component={AgendaPayment} />
                    <DefaultLayout
                        exact
                        path="/agenda/payment/detail/:userLp/:conceptCode"
                        component={AgendaPaymentDetail}
                    />
                    <DefaultLayout
                        exact
                        path="/agenda/multiplePayment/detail/:key"
                        component={MultiplePaymentAgendaDetail}
                    />
                    <DefaultLayout
                        exact
                        path="/agendaServicePaymentsConfirmationTicket"
                        component={AgendaServicePaymentsConfirmationTicket}
                    />
                    {/* CHARGES */}
                    <DefaultLayout
                        key="/charges/requestDebin"
                        exact
                        path="/charges/requestDebin"
                        component={RequestDebin}
                    />
                    <DefaultLayout
                        key="/charges/debin/detail/:idDebin"
                        exact
                        path="/charges/debin/detail/:idDebin"
                        component={SentDebinDetail}
                    />
                    <DefaultLayout
                        key="/charges/requestDebin/summary"
                        exact
                        path="/charges/requestDebin/summary"
                        component={CreateDebinSummary}
                    />
                    <DefaultLayout
                        key="/charges/generateDebin"
                        authorizedRoute={!!activeEnvironment?.permissions.charges}
                        exact
                        path="/charges/generateDebin"
                        component={DebinRequests}
                    />
                    <DefaultLayout
                        key="/charges/debin/addAccounts"
                        exact
                        path="/charges/debin/addAccounts"
                        component={DebinAddAccounts}
                    />
                    <DefaultLayout
                        key="/charges/debin/addAccounts/summary"
                        exact
                        path="/charges/debin/addAccounts/summary"
                        component={DebinAddAccountsSummary}
                    />
                    <DefaultLayout
                        key="/charges/debin/cancel/summary"
                        exact
                        path="/charges/debin/cancel/summary"
                        component={DebinCancelSummary}
                    />
                    <DefaultLayout
                        key="/v2/directDebit/list"
                        exact
                        path="/v2/directDebit/list"
                        component={ListDirectDebit}
                        authorizedRoute={!!activeEnvironment?.permissions["directDebit.access.menu"]}
                    />
                    <DefaultLayout
                        key="/v2/directDebit/create"
                        exact
                        path="/v2/directDebit/create"
                        component={NewDirectDebit}
                        authorizedRoute={!!activeEnvironment?.permissions["directDebit.manage"]}
                    />
                    <DefaultLayout
                        key="/directDebit/summary"
                        exact
                        path="/directDebit/summary"
                        component={NewDirectDebitSummary}
                        authorizedRoute={!!activeEnvironment?.permissions["directDebit.manage"]}
                    />
                    <DefaultLayout
                        key="/directDebit/summaryData"
                        exact
                        path="/directDebit/summaryData"
                        component={NewDirectDebitSummaryData}
                        authorizedRoute={!!activeEnvironment?.permissions["directDebit.manage"]}
                    />
                    <DefaultLayout
                        key="/directDebit/transaction"
                        exact
                        path="/directDebit/transaction"
                        component={NewDirectDebitTransaction}
                        authorizedRoute={!!activeEnvironment?.permissions["directDebit.access.menu"]}
                    />
                    <DefaultLayout
                        key="/directDebit/details/:idTransaction"
                        exact
                        path="/directDebit/details/:idTransaction"
                        component={DetailDirectDebit}
                        authorizedRoute={!!activeEnvironment?.permissions["directDebit.access.menu"]}
                    />
                    <DefaultLayout
                        key="/v2/addlimitrequest"
                        exact
                        path="/v2/addlimitrequest"
                        component={AddLimitRequest}
                    />
                    <DefaultLayout
                        key="/addlimitrequestconfirmation"
                        exact
                        path="/addlimitrequestconfirmation"
                        component={AddLimitRequestConfirmation}
                    />
                    {/* FORMS */}
                    <DefaultLayout exact path="/form/:idForm" component={Form} />

                    <DefaultLayout
                        key="/transaction/:idTransaction"
                        path="/transaction/:idTransaction"
                        component={Transaction}
                        exact
                    />

                    <DefaultLayout
                        path="/form/:idForm/processDetail"
                        component={FormPaymentLines}
                        componentProps={{
                            isConfirmation: true,
                        }}
                    />

                    <DefaultLayout
                        key="/transaction/:idTransaction/processDetail"
                        path="/transaction/:idTransaction/processDetail"
                        component={TransactionPaymentLines}
                    />

                    {/* PAYMENT LISTS */}
                    <DefaultLayout
                        key="/payments/payDebin"
                        authorizedRoute={!!activeEnvironment?.permissions["pay.debin"]}
                        exact
                        path="/payments/payDebin"
                        component={IncomingDebinList}
                    />
                    <DefaultLayout
                        key="/payments/recurrent"
                        exact
                        path="/payments/recurrent"
                        component={RecurrentDebins}
                    />
                    <DefaultLayout
                        key="/v2/debin/scheduled"
                        exact
                        path="/v2/debin/scheduled"
                        component={ProgrammedDebin}
                    />
                    <DefaultLayout
                        key="/v2/debin/scheduled/detail/:id"
                        exact
                        path="/v2/debin/scheduled/detail/:id"
                        component={DebinScheduledDetail}
                    />
                    <DefaultLayout
                        key="/v2/debin/scheduled/confirmation"
                        exact
                        path="/v2/debin/scheduled/confirmation"
                        component={DebinScheduledConfirmationPage}
                    />
                    <DefaultLayout
                        key="/payments/recurrent/load"
                        exact
                        path="/payments/recurrent/load"
                        component={LoadDebinRecurrency}
                    />
                    <DefaultLayout
                        key="/payments/recurrent/load/confirm"
                        exact
                        path="/payments/recurrent/load/confirm"
                        component={ConfirmRecurrencyDebin}
                    />
                    <DefaultLayout
                        key="/payments/recurrent/detail/:recurrencyId"
                        exact
                        path="/payments/recurrent/detail/:recurrencyId"
                        component={RecurrencyDetail}
                    />
                    <DefaultLayout
                        key="/payments/recurrent/load/transaction"
                        exact
                        path="/payments/recurrent/load/transaction"
                        component={PrestacionTransaction}
                    />
                    <DefaultLayout
                        key="/payments/recurrent/action/transaction"
                        exact
                        path="/payments/recurrent/action/transaction"
                        component={RecurrencyTransaction}
                    />
                    <DefaultLayout
                        key="/payments/recurrency/action/confirmation"
                        exact
                        path="/payments/recurrency/action/confirmation"
                        component={ConfirmRecurrencyDebinAction}
                    />
                    <DefaultLayout
                        key="/payments/payDebin/detail/:idDebin"
                        exact
                        path="/payments/payDebin/detail/:idDebin"
                        component={IncomingDebinDetail}
                    />
                    <DefaultLayout
                        key="/payments/payDebin/accept/confirm"
                        exact
                        path="/payments/payDebin/accept/confirm"
                        component={AcceptDebinConfirm}
                    />
                    <DefaultLayout
                        key="/payments/payDebin/decline/confirm"
                        exact
                        path="/payments/payDebin/decline/confirm"
                        component={DeclineDebinConfirm}
                    />
                    <DefaultLayout
                        key="/payments/payDebin/chargeback/confirm"
                        exact
                        path="/payments/payDebin/chargeback/confirm"
                        component={ChargebackDebinConfirm}
                    />
                    <DefaultLayout
                        key="/payments/payDebin/chargebackPull/confirm"
                        exact
                        path="/payments/payDebin/chargebackPull/confirm"
                        component={ChargebackPullConfirm}
                    />
                    <DefaultLayout
                        key="/confirmIncomingDebin/transaction"
                        exact
                        path="/confirmIncomingDebin/transaction"
                        component={IncomingDebinTransaction}
                    />
                    <DefaultLayout
                        key="/payThirdParties/list"
                        authorizedRoute={!!activeEnvironment?.permissions["pay.third.parties"]}
                        path="/payThirdParties/list"
                        component={PayThirdPartiesList}
                    />
                    <DefaultLayout
                        key="/payThirdParties/newPayment"
                        path="/payThirdParties/newPayment"
                        component={NewPayment}
                    />
                    <DefaultLayout
                        key="/v2/payThirdParties/newPayment"
                        path="/v2/payThirdParties/newPayment"
                        component={NewPaymentThirdParty}
                    />
                    <DefaultLayout
                        key="/payThirdParties/summary"
                        path="/payThirdParties/summary"
                        component={NewPaymentSummary}
                    />
                    <DefaultLayout
                        key="/payThirdParties/confirmation"
                        path="/payThirdParties/confirmation"
                        component={ThirdPaymentTicket}
                    />
                    <DefaultLayout
                        key="/payThirdParties/pending"
                        exact
                        path="/payThirdParties/pending"
                        component={ThirdPaymentTicket}
                    />
                    <DefaultLayout
                        key="/payThirdParties/cancelled"
                        path="/payThirdParties/cancelled"
                        component={ThirdPaymentTicket}
                    />
                    <DefaultLayout
                        key="/payThirdParties/:idTransaction/detail"
                        exact
                        path="/payThirdParties/:idTransaction/detail"
                        component={ThirdPaymentDetail}
                        componentProps={{
                            isConfirmation: false,
                            shouldLoadForm: false,
                        }}
                    />
                    {/* MANUAL MASS PAYMENT */}
                    <DefaultLayout path="/form/:idForm/manual" component={FormPaymentLines} />
                    {/* COMMUNICATIONS */}
                    <DefaultLayout exact path="/communications" component={CommunicationMain} />
                    <DefaultLayout exact path="/communications/compose" component={NewMessage} />
                    <DefaultLayout exact path="/communications/reply/:id" component={ReplyMessage} />
                    <DefaultLayout exact path="/communications/read/:id" component={ReadMessage} />
                    {/* CANCEL TRANSACTION */}

                    <DefaultLayout
                        key="/transactions/cancel"
                        exact
                        path="/transactions/cancel"
                        component={TransactionTicketCancelConfirmation}
                    />

                    {/* SIGN TRANSACTION */}

                    <DefaultLayout exact path="/transactions/sign" component={TransactionTicketSignConfirmation} />

                    {/* TRANSACTIONS */}

                    <DefaultLayout
                        key="/transactions/list"
                        exact
                        path="/transactions/list"
                        component={TransactionsList}
                    />

                    <DefaultLayout
                        key="/pendingTransaction/list"
                        exact
                        path="/pendingTransaction/list"
                        component={PendingTransactionList}
                    />

                    {/* EXTERNAL TRANSACTIONS */}
                    <DefaultLayout exact path="/externaltransactions/pending" component={ExternalTransaction} />
                    <DefaultLayout exact path="/externaltransactions/cancelled" component={ExternalTransaction} />
                    <DefaultLayout exact path="/externaltransactions/confirmation" component={ExternalTransaction} />
                    <DefaultLayout exact path="/externaltransactions/failed" component={ExternalTransaction} />
                    <DefaultLayout
                        key="/addlimitrequest/cancelled"
                        exact
                        path="/addlimitrequest/cancelled"
                        component={AddLimitTicket}
                    />
                    <DefaultLayout
                        key="/addlimitrequest/confirmation"
                        exact
                        path="/addlimitrequest/confirmation"
                        component={AddLimitTicket}
                    />
                    <DefaultLayout
                        key="/addlimitrequest/failed"
                        exact
                        path="/addlimitrequest/failed"
                        component={AddLimitTicket}
                    />
                    <DefaultLayout
                        key="/addlimitrequest/pending"
                        exact
                        path="/addlimitrequest/pending"
                        component={AddLimitTicket}
                    />
                    <DefaultLayout
                        key="/pendingTransaction/signMultiple"
                        exact
                        path="/pendingTransaction/signMultiple"
                        component={MultipleSignaturesSummary}
                    />
                    <DefaultLayout
                        key="/pendingTransaction/deleteMultiple"
                        exact
                        path="/pendingTransaction/deleteMultiple"
                        component={MultipleSignaturesDelete}
                    />
                    <DefaultLayout
                        key="/pendingTransaction/multipleSignatures/processing"
                        exact
                        path="/pendingTransaction/multipleSignatures/processing"
                        component={ProcessingMultipleSignatures}
                    />
                    <DefaultLayout
                        key="/pendingTransaction/multipleDelete/processing"
                        exact
                        path="/pendingTransaction/multipleDelete/processing"
                        component={ProcessingMultipleDelete}
                    />

                    <DefaultLayout
                        key="/transactions/list/filters"
                        exact
                        path="/transactions/list/filters"
                        component={TransactionsListFilters}
                    />

                    <DefaultLayout
                        key="/transactions/list/filters/results"
                        exact
                        path="/transactions/list/filters/results"
                        component={TransactionsFiltersResults}
                    />

                    <DefaultLayout path="/form/:formId/bankSearch/:fieldId" component={BankSearch} />
                    <DefaultLayout path="/form/:formId/templates" component={Templates} />
                    {/* EXTERNAL */}
                    <DefaultLayout key="/privacyPolicy" exact path="/privacyPolicy" component={PrivacyPolicy} />
                    <DefaultLayout
                        key="/termsAndConditions"
                        exact
                        path="/termsAndConditions"
                        component={TermsAndConditions}
                    />
                    <DefaultLayout key="/support" exact path="/support" component={SupportInfo} />
                    {/* administration */}
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/users/invite"
                        component={UserInvite}
                        authorizedRoute={isAdministrator}
                    />
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/users/inviteStep2"
                        component={UserInviteStep2}
                        authorizedRoute={isAdministrator}
                    />
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/users/GroupSignature"
                        component={UserInviteGroupSignature}
                        authorizedRoute={isAdministrator}
                    />
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/users/inviteStep3"
                        component={UserInviteStep3}
                        authorizedRoute={isAdministrator}
                    />
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/signature/:idTransaction/ticket"
                        component={AdministrationMediumSignatureTicket}
                        authorizedRoute={isAdministrator}
                    />
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        path="/administration/users"
                        component={Administration}
                        authorizedRoute={isAdministrator}
                    />
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        path="/administration/groups"
                        component={Administration}
                        authorizedRoute={isAdministrator}
                    />
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        path="/administration/simple/signaturesSchemes"
                        component={Administration}
                        authorizedRoute={isAdministrator}
                    />
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        path="/administration/medium/signaturesSchemes"
                        component={Administration}
                        authorizedRoute={isAdministrator}
                    />
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        path="/administration/advanced/signaturesSchemes"
                        component={Administration}
                        authorizedRoute={isAdministrator}
                    />
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        path="/administration/restrictions"
                        component={Administration}
                        authorizedRoute={isAdministrator}
                    />
                    <DefaultLayout
                        excludeEnvType={["retail"]}
                        path="/administration"
                        component={Administration}
                        authorizedRoute={isAdministrator}
                    />
                    {/* end of administration */}
                    {/* Deposits (legacy DefaultLayout when UX dashboard off; v3 shell owns these paths when on) */}
                    <DefaultLayout
                        key="/deposits"
                        exact
                        path="/deposits"
                        component={Deposits}
                        authorizedRoute={!!activeEnvironment?.permissions?.deposits}
                    />
                    <DefaultLayout key="/deposits/:id/" exact path="/deposits/:id/" component={DepositDetails} />
                    <DefaultLayout
                        key="/depositsConstitute"
                        exact
                        path="/depositsConstitute"
                        component={DepositConstitute}
                    />
                    <DefaultLayout
                        key="/v2/depositsConstitute"
                        exact
                        path="/v2/depositsConstitute"
                        component={DepositsConstituteV2}
                    />
                    {/* CURRENCY EXCHANGE (shell v3 cuando UX dashboard on) */}
                    <DefaultLayout
                        key="/v2/investment/currencyExchange"
                        exact
                        path="/v2/investment/currencyExchange"
                        component={CurrencyExchangePage}
                        authorizedRoute={
                            !!activeEnvironment?.permissions?.["investment.currencyExchange.buy"] ||
                            !!activeEnvironment?.permissions?.["investment.currencyExchange.sell"]
                        }
                    />
                    <DefaultLayout
                        key="/v2/investment/currencyExchange/confirm"
                        exact
                        path="/v2/investment/currencyExchange/confirm"
                        component={CurrencyExchangeConfirmPage}
                        authorizedRoute={
                            !!activeEnvironment?.permissions?.["investment.currencyExchange.buy"] ||
                            !!activeEnvironment?.permissions?.["investment.currencyExchange.sell"]
                        }
                    />
                    <DefaultLayout
                        key="/currencyExchangeConfirmation/:idTransaction/ticket"
                        exact
                        path="/currencyExchangeConfirmation/:idTransaction/ticket"
                        component={CurrencyExchangeTicket}
                    />
                    <DefaultLayout key="/depositsSummary" exact path="/depositsSummary" component={DepositSummary} />
                    <DefaultLayout
                        key="/depositsConfirmation/:idTransaction/ticket"
                        exact
                        path="/depositsConfirmation/:idTransaction/ticket"
                        component={DepositConstituteTicket}
                    />
                    <DefaultLayout
                        key="/deposit/:id/setProductAlias"
                        exact
                        path="/deposit/:id/setProductAlias"
                        component={SetProductAlias}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundcorpOperations}
                        exact
                        path="/fundcorpOperations"
                        component={FundcorpOperationsMain}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/rescue"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/fundcorpOperations/rescue"
                        component={FundRescue}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/rescue/:fondoNumero/:fondoAbreviatura/:fondoMoneda/:cuotapartistaNumero"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/fundcorpOperations/rescue/:fondoNumero/:fondoAbreviatura/:fondoMoneda/:cuotapartistaNumero"
                        component={FundRescue}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/rescue/back"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/fundcorpOperations/rescue/back"
                        component={FundRescue}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/rescue/pending"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/fundcorpOperations/rescue/pending"
                        component={RescueTicket}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/rescue/confirmation"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/fundcorpOperations/rescue/confirmation"
                        component={RescueTicket}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/rescue/cancelled"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/fundcorpOperations/rescue/cancelled"
                        component={RescueTicket}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/rescue/failed"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/fundcorpOperations/rescue/failed"
                        component={RescueTicket}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/rescue/scheduled"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/fundcorpOperations/rescue/scheduled"
                        component={RescueTicket}
                    />
                    <DefaultLayout
                        key="/rescue/scheduled/cancel"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/rescue/scheduled/cancel"
                        component={FundScheduledCancel}
                    />
                    <DefaultLayout
                        key="/rescue/summary"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/rescue/summary"
                        component={FundRescueSummary}
                    />
                    <DefaultLayout
                        key="/cancelSubscribe/summary"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/cancelSubscribe/summary"
                        component={FundCancelSummary}
                    />
                    <DefaultLayout
                        key="/cancelSubscribe/transaction"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/cancelSubscribe/transaction"
                        component={CancelTicket}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/subscribe"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/fundcorpOperations/subscribe"
                        component={FundSubscribe}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/subscribe/:fondoNumero/:cuotapartistaNumero"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/fundcorpOperations/subscribe/:fondoNumero/:cuotapartistaNumero"
                        component={FundSubscribe}
                    />
                    <DefaultLayout
                        key="/subscribe/summary"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/subscribe/summary"
                        component={FundSubscribeSummary}
                    />
                    <DefaultLayout
                        key="/subscribe/pending"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/subscribe/pending"
                        component={SubscribeTicket}
                    />
                    <DefaultLayout
                        key="/subscribe/confirmation"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/subscribe/confirmation"
                        component={SubscribeTicket}
                    />
                    <DefaultLayout
                        key="/subscribe/cancelled"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/subscribe/cancelled"
                        component={SubscribeTicket}
                    />
                    <DefaultLayout
                        key="/subscribe/failed"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/subscribe/failed"
                        component={SubscribeTicket}
                    />
                    <DefaultLayout
                        key="/subscribe/scheduled"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundRescue}
                        exact
                        path="/subscribe/scheduled"
                        component={SubscribeTicket}
                    />
                    <DefaultLayout
                        key="/subscribe/scheduled/cancel"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/subscribe/scheduled/cancel"
                        component={FundScheduledCancel}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/investor-profile"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/fundcorpOperations/investor-profile"
                        component={InvestorProfile}
                    />
                    <DefaultLayout
                        key="/fundcorpOperations/registerShareAccount"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/fundcorpOperations/registerShareAccount"
                        component={FundRegisterShareAccount}
                    />
                    <DefaultLayout
                        key="/registerShareAccount/success"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/registerShareAccount/success"
                        component={ShareAccountTicket}
                    />
                    <DefaultLayout
                        key="/registerShareAccount/failed"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundSubscribe}
                        exact
                        path="/registerShareAccount/failed"
                        component={ShareAccountTicket}
                    />

                    <DefaultLayout
                        key="/fundInformation"
                        authorizedRoute={!!activeEnvironment?.permissions?.fundcorpInformation}
                        exact
                        path="/fundInformation"
                        component={FundcorpInformationMain}
                    />

                    {/* CEDIP (shell v3 cuando UX dashboard on) */}
                    <DefaultLayout
                        key="/cedip"
                        authorizedRoute={!!activeEnvironment?.permissions?.cedip}
                        exact
                        path="/cedip"
                        component={CedipList}
                    />
                    <DefaultLayout
                        key="/cedip/:idCedip/:fraction"
                        authorizedRoute={!!activeEnvironment?.permissions?.cedip}
                        exact
                        path="/cedip/:idCedip/:fraction"
                        component={CedipDetail}
                    />
                    <DefaultLayout
                        key="/cedip/reject"
                        authorizedRoute={!!activeEnvironment?.permissions?.cedip}
                        exact
                        path="/cedip/reject"
                        component={AcceptOrRejectCedip}
                    />
                    <DefaultLayout
                        key="/cedip/accept"
                        authorizedRoute={!!activeEnvironment?.permissions?.cedip}
                        exact
                        path="/cedip/accept"
                        component={AcceptOrRejectCedip}
                    />
                    <DefaultLayout
                        key="/cedip/ticket"
                        authorizedRoute={!!activeEnvironment?.permissions?.cedip}
                        exact
                        path="/cedip/ticket"
                        component={RejectCedipTicket}
                    />
                    {/* fixedTermAcceptance, financing, metrocorp, ecomex: legacy DefaultLayout (UX off) */}
                    <DefaultLayout
                        key="/fixedTermAcceptance"
                        exact
                        path="/fixedTermAcceptance"
                        component={FixedTermAcceptance}
                    />
                    <DefaultLayout
                        key="/fixedTermAcceptance/detail/:idDebin"
                        exact
                        path="/fixedTermAcceptance/detail/:idDebin"
                        component={FixedTermAcceptanceDetail}
                    />
                    <DefaultLayout
                        key="/fixedTermAcceptance/accept/confirm"
                        exact
                        path="/fixedTermAcceptance/accept/confirm"
                        component={AcceptFixedTermConfirm}
                    />
                    <DefaultLayout
                        key="/fixedTermAcceptance/decline/confirm"
                        exact
                        path="/fixedTermAcceptance/decline/confirm"
                        component={DeclineFixedTermConfirm}
                    />
                    <DefaultLayout key="/financing" exact path="/financing" component={LegacyFinancingIndexRedirect} />
                    <DefaultLayout key="/ecomex" exact path="/ecomex" component={LegacyEcomexIndexRedirect} />
                    <DefaultLayout
                        key="/financing/categories"
                        exact
                        path="/financing/categories"
                        component={FinancingListCategories}
                    />
                    <DefaultLayout key="/financing/:id" exact path="/financing/:id" component={FinancingId} />
                    <DefaultLayout
                        key="/financing/detail/:id"
                        exact
                        path="/financing/detail/:id"
                        component={FinancingDetail}
                    />
                    <DefaultLayout
                        key="/financing/feeds/detail/:id"
                        exact
                        path="/financing/feeds/detail/:id"
                        component={FeedsDetail}
                    />
                    <DefaultLayout key="/metrocorp" exact path="/metrocorp" component={MetrocorpLegacyRoute} />
                    <DefaultLayout
                        key="/v3/metrocorp"
                        exact
                        path="/v3/metrocorp"
                        component={MetrocorpV3Route}
                    />
                    <DefaultLayout
                        key="/ecomex/consultOperations"
                        exact
                        path="/ecomex/consultOperations"
                        component={EcomexOperationsMain}
                    />
                    <DefaultLayout
                        key="/ecomex/informativeRegime"
                        exact
                        path="/ecomex/informativeRegime"
                        component={EcomexInformativeRegimeMain}
                    />
                    <DefaultLayout
                        key="/ecomex/alertsAndDues"
                        exact
                        path="/ecomex/alertsAndDues"
                        component={EcomexAlertsAndDuesMain}
                    />
                    <DefaultLayout
                        key="/ecomex/newRequests"
                        authorizedRoute={!!activeEnvironment?.permissions?.ecomexNewRequests}
                        exact
                        path="/ecomex/newRequests"
                        component={EcomexNewRequests}
                    />
                    <DefaultLayout
                        key="/ecomex/requestHistory"
                        authorizedRoute={!!activeEnvironment?.permissions?.ecomexRequestHistory}
                        exact
                        path="/ecomex/requestHistory"
                        component={EcomexRequestHistory}
                    />
                    <DefaultLayout
                        key="/ecomex/transaction"
                        exact
                        path="/ecomex/transaction"
                        component={EcomexConfirmTransaction}
                    />
                    <DefaultLayout
                        key="/ecomex/finished"
                        exact
                        path="/ecomex/finished"
                        component={ExcomexTransactionSuccess}
                    />
                    <DefaultLayout key="/ecomex/failed" exact path="/ecomex/failed" component={EcomexTransaction} />
                    <DefaultLayout key="/ecomex/pending" exact path="/ecomex/pending" component={EcomexTransaction} />
                    <DefaultLayout
                        key="/ecomex/cancelled"
                        exact
                        path="/ecomex/cancelled"
                        component={EcomexTransaction}
                    />
                </Switch>
                <BackButtonListener />
                <Route path="/" component={SessionAboutToExpire} />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    hasActiveSession: sessionSelectors.isLoggedIn(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    isAdministrator: sessionSelectors.isAdministrator(state),
    uxDashboardImprovements: isUxDashboardImprovementsEnabled(),
});

export default withRouter(connect(mapStateToProps)(PrivateRoutes));
